<script>
    import {goto} from "@sveltech/routify";
    import {_} from 'svelte-i18n';
    import {getContext} from "svelte";

    import {
        Navbar,
        NavbarBrand,
        Nav,
        NavItem,
        NavLink
    } from 'sveltestrap';

    export let event;
    export let toggleEditMode;

    const MyAnalytics = getContext('MyAnalytics');

    const editModeActive = getContext('editMode');

    const readyForCampaign = event.event_from && event.event_to;

    const handleStartCampaign = async () => {
        MyAnalytics.logEvent('event_campaign_new_click', {
            event_id: event.id,
        });
        $goto('/app/campaigns/new/:eventId', { eventId: event.id });
    }
</script>

<footer>
    <Navbar class="navbar fixed-bottom navbar-expand-lg navbar-themed pb-4" expand="md">
        <NavbarBrand>
        </NavbarBrand>
        <Nav>
            <NavItem>
                <NavLink on:click={toggleEditMode} class="btn btn-secondary">
                    {#if $editModeActive}
                        {$_('global.cancelEdit')}
                    {:else}
                        {$_('global.edit')}
                    {/if}
                </NavLink>
            </NavItem>
            {#if !$editModeActive && readyForCampaign}
                <NavItem>
                    <NavLink on:click={handleStartCampaign} class="btn btn-primary">
                        {$_('page.event.view.startCampaignButton')}
                    </NavLink>
                </NavItem>
            {/if}
        </Nav>
    </Navbar>
</footer>